import { render, staticRenderFns } from "./notify-store-dialog.vue?vue&type=template&id=1dd36298&scoped=true&"
import script from "./notify-store-dialog.vue?vue&type=script&lang=js&"
export * from "./notify-store-dialog.vue?vue&type=script&lang=js&"
import style0 from "./notify-store-dialog.vue?vue&type=style&index=0&id=1dd36298&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd36298",
  null
  
)

export default component.exports